import React from 'react';
import { AlertTriangle } from 'lucide-react';

const Alert = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-lg shadow-xl w-full max-w-md mx-4 p-6 border border-amber-500/20">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center mb-4">
            <AlertTriangle className="w-6 h-6 text-red-500" />
          </div>
          <h3 className="text-xl font-semibold bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 bg-clip-text  mb-2">
            Confirm Deletion
          </h3>
          <p className="text-gray-400 text-center mb-6">{message}</p>
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-amber-500/20 rounded-lg text-amber-500 hover:bg-amber-500/10 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:from-red-700 hover:to-red-800 transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alert;